import React, { useState, useEffect } from 'react';
import OtpModal from './OTPModal';
import OtpOptions from './OtpOptions';
import { useTranslation } from 'react-i18next';


interface OtpModalContainerProps {
  open: boolean;
  handleClose: () => void;
  verficationCallback?: (isVerified: boolean) => void;
  email: string;
}

const OtpModalContainer: React.FC<OtpModalContainerProps> = ({ open, handleClose,
  verficationCallback, email }) => {
  const [step, setStep] = useState('enterCode');
  const { t } = useTranslation();

  const data: any = t('managePreferences', { returnObjects: true, defaultValue: {} });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [liveMessage, setLiveMessage] = useState('');


  useEffect(() => {
    if (step === 'verificationSuccess' && typeof verficationCallback === 'function') {
      verficationCallback(true);
      setLiveMessage('Your OTP has been successfully verified.');
    }else{
      setLiveMessage('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);


  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };


  return (
    <>
     <div
      aria-live="polite"
      aria-atomic="true"
      id="otp-status-message"
      style={{
        position: 'absolute',
        left: '-9999px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
    >
      {liveMessage}
    </div>
      <OtpModal
        open={open}
        handleClose={handleClose}
        header={step === 'managePreferences' ? data.title : data.otpTitle}
        body={
          <OtpOptions step={step}
            setStep={setStep}
            header={step === 'managePreferences' ? data.title : data.otpTitle}
            handleClose={handleClose}
            email={email}
            setSnackbarMessage={setSnackbarMessage}
            setSnackbarOpen={setSnackbarOpen}
            setSnackbarSeverity={setSnackbarSeverity}
            snackbarMessage={snackbarMessage}
            snackbarOpen={snackbarOpen} />}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        handleSnackbarClose={handleSnackbarClose}
      />
    </>
  );
};

export default OtpModalContainer;